<template>
  <reg-card>
    <div class="card-icon">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ff825d" stroke-width="2">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    </div>
    <h2 class="title">Notificações extra</h2>
    <p class="sub">
      O teu plano inclui
      <strong class="orange">{{ notifIncluidas.toLocaleString("pt-PT") }} notificações</strong>
      semanais. Queres adicionar mais?
    </p>

    <div class="addon-list">
      <button
        v-for="opt in opcoes" :key="opt.id"
        class="addon-btn"
        :class="{ selected: selecionado === opt.id }"
        @click="selecionado = selecionado === opt.id ? null : opt.id"
      >
        <div class="addon-left">
          <span class="addon-label">{{ opt.label }}</span>
          <span class="addon-notif">+ {{ opt.notificacoes_extra.toLocaleString("pt-PT") }} notif/semana</span>
        </div>
        <span class="addon-preco">{{ opt.preco_calculado_valor }}€/mês</span>
      </button>

      <button class="addon-btn addon-none" :class="{ selected: selecionado === null }" @click="selecionado = null">
        Nenhum
      </button>
    </div>

    <p class="preco-hint">Preço calculado a {{ precoNotifExtra }}€ por notificação extra</p>

    <button class="btn-dark" @click="$emit('done', selecionado)">AVANÇAR</button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";

export default {
  name: "OStep3",
  components: { RegCard },
  props: {
    opcoes:         { type: Array,  default: () => [] },
    notifIncluidas: { type: Number, default: 0 },
    precoNotifExtra:{ type: Number, default: 0.05 },
    value:          { default: null },
  },
  data() {
    return { selecionado: this.value };
  },
};
</script>

<style scoped lang="scss">
.card-icon  { width: 36px; height: 36px; background: #fff5f0; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 12px; }
.title      { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 6px; }
.sub        { font-size: 13.5px; color: #7a736e; margin-bottom: 14px; line-height: 1.5; }
.orange     { color: #ff825d; }
.addon-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 8px; }
.addon-btn  {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 16px; border: 1.5px solid #e8e4e0; border-radius: 10px;
  background: #fff; cursor: pointer; font-family: inherit; transition: all .15s;
  &:hover { border-color: #ff825d; }
  &.selected { border-color: #ff825d; background: #ff825d;
    .addon-label, .addon-notif, .addon-preco { color: #fff; }
  }
  &.addon-none { justify-content: center; color: #b0a8a0; font-size: 14px; font-weight: 600; }
  &.addon-none.selected { border-color: #e8e4e0; background: #f7f4f1; color: #7a736e; }
}
.addon-left  { display: flex; flex-direction: column; }
.addon-label { font-size: 14px; font-weight: 600; color: #1a1210; }
.addon-notif { font-size: 12px; color: #b0a8a0; }
.addon-preco { font-size: 14px; font-weight: 700; color: #1a1210; white-space: nowrap; }
.preco-hint  { font-size: 11px; color: #b0a8a0; text-align: center; margin-bottom: 4px; }
.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; margin-top: 12px; &:hover { background: #2d2420; } }
</style>
